import { RefreshCw } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";

// The same button on every screen: fetches the screen's data again right away.
export default function RefreshButton({ onClick, refreshing, className = "" }) {
  const { t } = useLang();
  return (
    <Button variant="outline" size="sm" onClick={onClick} disabled={refreshing} aria-label={t("common.refresh")}
      data-testid="refresh-button" className={`gap-1.5 h-9 ${className}`}>
      <RefreshCw className={`w-4 h-4 ${refreshing ? "animate-spin" : ""}`} />
      <span className="hidden sm:inline">{t("common.refresh")}</span>
    </Button>
  );
}
